export const testPrintBase64String = 'G0AgICAgICAgICAgICAgICAgICAgVGVzdCB0aXNrdRtkBh1WQQM='
